// extracted by mini-css-extract-plugin
module.exports = {"root":"Error_root__2w817","icon":"Error_icon__shVP6","active":"Error_active__192wb"};